<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Create a new workspace</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!workspaceCreated" class="container">
            <div class="form-group">
                <label for="Name">Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of workspace">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="Description">Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of workspace"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="StartupUrl">Startup url:</label>
                <input v-model="startupUrl" type="text" class="form-control" placeholder="Startup url - only for advanced scenarios">
                <ValidationError context="StartupUrl" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="statusInitial || statusInvalid" @click="handleCreateWorkspaceCommandV1" type="button" class="btn btn-primary btn-lg">Create</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h4 class="fg-color-blue">Workspace was created</h4>
            <br />

            <div v-if="createdWorkspaceId">
                <a :href="`/#/admin/organizations/workspaces/manage/${createdWorkspaceId}`" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                    <span>Manage workspace members</span>
                </a>

                <h4 class="fg-color-blue" style="margin: 20px 0;">or</h4>
            </div>

            <button @click="handleFinish" class="btn btn-secondary text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-workspace-plus" aria-hidden="true"></i>
                <span>Add another workspace</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Workspaces/queries-vue-component";
    import Commands from "@Organizations/Workspaces/commands-vue-component";
    import QueriesUsers from "@Organizations/Users/queries-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@common/Components/ValidationError.vue";

    @Component
    export default class CreateUserPage extends mixins(PageBase, PageStatus, Queries, QueriesUsers, Commands) {
        name = '';
        description = '';
        startupUrl = '';
        workspaceCreated = false;

        mounted() {
            this.setTitle('Create a new workspace');
            this.runCurrentUserQueryV1(false, false, true)
        }

        get organizationWorkspacesModel() { return this.model?.OrganizationWorkspaces; }
        get workspaces() { return this.organizationWorkspacesModel?.Workspaces || []; }
        get createdWorkspaceId() { return this.workspaces.find(_ => _.Name == this.name)?.WorkspaceId; }

        handleCreateWorkspaceCommandV1() {
            this.$clearValidationErrors();
            this.setStatusInvoking();
            this.invokeCreateWorkspaceCommandV1('0', this.tid, this.name, this.description, this.startupUrl);
        }

        succeedCreateWorkspaceCommandV1() {
            this.setStatusSucceed();
            this.runWorkspacesByOrganizationQueryV1(this.tid);
            this.workspaceCreated = true;
        }

        invalidCreateWorkspaceCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedCreateWorkspaceCommandV1(status) {
            this.setStatusFailed();
        }

        handleFinish() {
            this.name = '';
            this.description = '';
            this.startupUrl = '';
            this.workspaceCreated = false;
            this.setStatusInitial();
        }
    }
</script>

<style scoped>
</style>